export function IngredientSelectField({ label = 'Insumo', value, options, onChange, onCreateNew }: { label?: string; value: string; options: Array<[string, string]>; onChange: (value: string) => void; onCreateNew?: () => void }) {
  return <label className="field">
    <span>{label}</span>
    <div className="field-with-action">
      <select value={value} onChange={(event) => onChange(event.target.value)}>{options.map(([id, text]) => <option key={`${id}-${text}`} value={id}>{text}</option>)}</select>
      {onCreateNew && <button className="text-button" onClick={onCreateNew} type="button">+ Nuevo</button>}
    </div>
  </label>;
}
